import { render, staticRenderFns } from "./UpdateSchedulerAlignersOasis.vue?vue&type=template&id=8f7e1f46&scoped=true"
import script from "./UpdateSchedulerAlignersOasis.vue?vue&type=script&lang=js"
export * from "./UpdateSchedulerAlignersOasis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7e1f46",
  null
  
)

export default component.exports